/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

:host {
  --scroll-height: 25vh;
  --_input-background: var(--background);
  contain: initial;
}

[name='caret'] {
  right: var(--nve-ref-size-300);
  align-self: center;
  pointer-events: none;
  position: absolute;
}

[internal-host]:has(nve-menu:focus-within) [input] {
  outline: 0 !important;
}

:host(:state(selected)) {
  --font-weight: var(--nve-ref-font-weight-semibold);
}

:host(:state(multiple)) {
  --padding: 0 var(--nve-ref-size-100);
}

:host(:state(multiple)) [input] {
  padding: var(--padding);
}

.tags {
  width: fit-content;
  display: flex;
  gap: var(--nve-ref-space-xxs);
  align-items: center;
}

.tags-label {
  padding: 0 var(--nve-ref-size-200);
  font-size: var(--font-size);
  cursor: var(--cursor);
  font-weight: var(--font-weight);
  text-wrap: nowrap;
  display: none;
  align-items: center;
  pointer-events: none;
}

:host(:state(multiple-overflow):not([tag-layout='wrap'])) .tags {
  opacity: 0;
  pointer-events: none;
  position: absolute;
}

:host(:state(multiple-overflow):not([tag-layout='wrap'])) .tags-label {
  display: flex;
}

nve-tag {
  --background: color-mix(in oklab, var(--color) 15%, var(--_input-background));
  --padding: var(--nve-ref-size-100) var(--nve-ref-size-200);
  --cursor: pointer !important;
}

::slotted(select) {
  display: none !important;
}

:host([status='error']),
:host(:state(invalid)),
:host(:state(error)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-danger-emphasis-color);
}

:host([status='success']),
:host(:state(success)) {
  --border: var(--nve-ref-border-width-md) solid var(--nve-sys-support-success-emphasis-color);
}

:host(:state(disabled)) {
  --border: var(--nve-ref-border-width-md) solid transparent;
}

[name='prefix-icon'] {
  display: contents;
}

nve-dropdown {
  --padding: var(--nve-ref-size-200);
}

nve-menu {
  contain: content;
  --max-height: var(--scroll-height);
}

nve-menu-item {
  --text-transform: initial;
  contain: content;
  content-visibility: auto;
}

[internal-host]:has([matches]) nve-menu-item {
  --color: var(--nve-sys-text-muted-color);
}

nve-menu-item nve-icon {
  --color: inherit;
}

input[type='checkbox'] {
  accent-color: var(--nve-sys-accent-secondary-background);
}

nve-checkbox:not(:state(disabled)) {
  --border-color: var(--nve-ref-border-color-emphasis);
}

nve-menu-item:not(:state(selected)) nve-icon[name='check'] {
  opacity: 0;
}

slot:not([name]),
slot[name*='option-'] {
  display: contents;
}

[matches] {
  font-weight: var(--nve-ref-font-weight-medium);
  color: var(--nve-sys-text-emphasis-color);
}

[name='footer'] {
  display: none;
  min-height: var(--nve-ref-size-900);
  margin: calc(var(--nve-ref-size-200) * -1);
  width: calc(100% + calc(var(--nve-ref-size-200) * 2));
  border-top: var(--nve-ref-border-width-sm) solid var(--nve-ref-border-color-muted);
  padding: 0 var(--nve-ref-size-200);
  gap: var(--nve-ref-space-sm);
  justify-content: center;
  align-items: center;
}

:host(:state(footer-content)) [name='footer'] {
  display: flex;
}

nve-menu-item[part='create-option'] {
  --color: var(--nve-sys-text-muted-color);
  font-style: italic;

  span::first-letter {
    text-transform: uppercase;
  }
}

:host([tag-layout='wrap']:state(multiple-overflow)) {
  [input] {
    min-height: var(--height);
    height: fit-content;
    flex-direction: column;
    width: 100%;
  }

  .tags {
    padding-block-start: var(--nve-ref-size-50);
    flex-wrap: wrap;
  }
}
